// Import general mixin for shared functionality.
import mixin from './mixin';

import SourceSet from './components/SourceSet.vue';

const ShopOverviewApp = {
    mixins: [mixin],
    components: { SourceSet },
    data() {
        return {
            dataJson: [],
            dataLimit: 12,
            dataSortinglabel: 'Sortering',
            dataStandardlabel: 'standaard',
            dataIncreasinglabel: 'prijs oplopend',
            dataDecreasinglabel: 'prijs aflopend',
            page: 0,
            sorting: 'standaard',
            cart: [],
        }
    },
    computed: {
        sortingOptions() {
            return [this.dataStandardlabel, this.dataIncreasinglabel, this.dataDecreasinglabel];
        },
        items() {
            return this.dataJson;
        },
        sortedItems() {
            switch (this.sorting) {
                case this.dataStandardlabel:
                    return this.items;
                case this.dataIncreasinglabel:
                    return [...this.items].sort((a, b) => a.Price - b.Price);
                case this.dataDecreasinglabel:
                    return [...this.items].sort((a, b) => b.Price - a.Price);
                default:
                    return this.items;
            }
        },
        limitedItems() {
            return this.sortedItems.slice(0, (this.page + 1) * this.dataLimit);
        },
    },
    methods: {
        init() {
            if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortinglabel) this.dataSortinglabel = this.$el.dataset.sortinglabel;
            if (this.$el.dataset.standardlabel) this.dataStandardlabel = this.$el.dataset.standardlabel;
            if (this.$el.dataset.increasinglabel) this.dataIncreasinglabel = this.$el.dataset.increasinglabel;
            if (this.$el.dataset.decreasinglabel) this.dataDecreasinglabel = this.$el.dataset.decreasinglabel;
            if (this.$el.dataset.carturl) this.dataCartUrl = this.$el.dataset.carturl;

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('page')) this.page = parseInt(urlParams.get('page'));

            if (localStorage.getItem('cart')) {
                this.cart = JSON.parse(localStorage.getItem('cart'));
            }
        },
        loadMore() {
            this.page++;
            this.updateUrl();
        },
        updateUrl() {
            if (!this.page) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.page) urlParams.append('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
        openDropdown(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.add('is-active');

                document.addEventListener('click', (event) => {
                    if (!this.$refs[ref].contains(event.target)) {
                        this.$refs[ref].classList.remove('is-active');
                    }
                });
            }
        },
        setSorting(sorting, ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.remove('is-active');
            }
            this.sorting = sorting;
            const url = new URL(location);
            url.searchParams.set('sorting', this.sorting);
            if (this.sorting === 'standaard') url.searchParams.delete('sorting');
            history.pushState({}, '', url);
        },
        download(url, name) {
            var link = document.createElement('a');
            link.setAttribute('download', name);
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        addToCart(item) {
            if (this.cart.find(product => product.id === item.Key)) {
                this.cart.find(product => product.id === item.Key).amount++;
            }
            else {
                this.cart.push({
                    id: item.Key,
                    name: item.Name,
                    price: item.Price,
                    imagesrc: item.ThumbnailImageSrc,
                    imagecrops: item.ThumbnailImageCrops,
                    focalpoint: item.ThumbnailFocalPoint,
                    url: item.Url,
                    amount: 1,
                });
            }
            
            localStorage.setItem('new', item.Key);
            localStorage.setItem('cart', JSON.stringify(this.cart));
            window.location.href = this.dataCartUrl;
        }
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('sorting')) this.sorting = urlParams.get('sorting');
    },
    mounted() {
        this.init();
    },
};

export default ShopOverviewApp;
